import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { PricePlanTier } from '@utils/types/back-office/price-plans-bo.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

export interface CreatePricePlanPayload {
  name: string;
  pricePerUnit?: string;
  tiers: PricePlanTier[];
}

export const useCreatePricePlan = () => {
  const queryClient = useQueryClient();

  const createPricePlan = async (data: CreatePricePlanPayload) => {
    const response = await Axios.post(`${POST_URL().createPricePlan}`, data);
    return response.data;
  };

  return useMutation<void, AxiosError<BaseError>, CreatePricePlanPayload>(
    createPricePlan,
    {
      onSuccess: () => {
        queryClient.invalidateQueries('pricePlans');
      }
    }
  );
};
